// sortHreflangs.js
/**
 * A function that sorts hreflangs based on the primary locale and 'x-default'.
 * 
 * @param {Array} hreflangs - Data array from hreflang data.
 * @param {string} locale - Main locale, which should come first.
 * @returns {Array} Sorted array of hreflangs.
 */

export default function sortHreflangs(hreflangs, locale) {
    return hreflangs.sort((a, b) => {
      if (a.locale === locale) return -1;
      if (b.locale === locale) return 1;
  
      if (a.locale === 'x-default') return -1;
      if (b.locale === 'x-default') return 1;
      
      return 0;
    });
  }
  